'use client';

let timeout;
const FALLBACK_TIMEOUT_MS = 1000;
const checkScrollEndHandler = (scrollElement, callback) => {
  // Use native implementation if available
  if ('onscrollend' in scrollElement) {
    // 'once: true' ensures the listener is  after it fires
    scrollElement.addEventListener('scrollend', callback, { once: true });
  } else {
    // Fallback for browsers that don't support onscrollend (like Safari)
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      callback();
    }, FALLBACK_TIMEOUT_MS);
  }
};

export const scrollToElementPromise = (
  element: Element,
  options?: {
    parent?: HTMLDivElement | null;
    offset?: number;
    checkScrollEnd?: boolean;
  }
) => {
  const computedOffset = options?.offset || -56; // Header height
  return new Promise<void>((resolve) => {
    const rect = element.getBoundingClientRect();
    const parent = options?.parent;
    const scrollElement = parent ?? (window as any);
    const scrollY = parent ? parent.scrollTop : window.scrollY;
    const top = rect.top + scrollY;
    scrollElement.scrollTo({
      top: top + computedOffset,
      behavior: 'smooth',
    });

    if (options?.checkScrollEnd) {
      checkScrollEndHandler(scrollElement, resolve);
    } else {
      resolve();
    }
  });
};
